export default __webpack_public_path__ + "static/Energy_Bar-6f53a56f4f867dc67e5813cf96372168.jpg";